import { Breadcrumbs } from '@mui/material';
import { styled } from '@mui/material';

export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  marginTop: '1em',
  marginBottom: '1em',
  [theme.breakpoints.down('sm')]: {
    marginTop: '1.1em',
  },
  '& > ol': {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    },
  },
}));
